export interface Bid {
  id: string
  reference: string
  title: string
  category: string
  publicationDate: string
  deadline: string
  status: 'open' | 'closing-soon' | 'closed'
  description: string
  estimatedValue?: string
}

export const bids: Bid[] = [
  {
    id: '1',
    reference: 'AU-AFRI-2026-001',
    title: 'Supply of Medical Equipment for AU Health Partnership Programme',
    category: 'Health & Medical',
    publicationDate: '2026-04-15',
    deadline: '2026-06-30',
    status: 'open',
    description:
      'Procurement of advanced medical diagnostic equipment for distribution across 15 African Union member states as part of the AU Health Systems Strengthening Initiative.',
    estimatedValue: '£2,500,000',
  },
  {
    id: '2',
    reference: 'AU-AFRI-2026-002',
    title: 'Construction of Trade Facilitation Centre in Accra',
    category: 'Infrastructure',
    publicationDate: '2026-04-20',
    deadline: '2026-06-15',
    status: 'closing-soon',
    description:
      "Design and construction of a modern trade facilitation centre to support AfCFTA implementation and Africa's global trade partnerships.",
    estimatedValue: '£8,750,000',
  },
  {
    id: '3',
    reference: 'AU-AFRI-2026-003',
    title: 'Digital Skills Training Programme Implementation',
    category: 'Education & Training',
    publicationDate: '2026-04-10',
    deadline: '2026-07-10',
    status: 'open',
    description:
      'Delivery of comprehensive digital skills training to 5,000 young professionals across AU member states, focusing on AI, data science, and software development.',
    estimatedValue: '£1,200,000',
  },
  {
    id: '4',
    reference: 'AU-AFRI-2026-004',
    title: 'Climate Finance Advisory Services',
    category: 'Consulting Services',
    publicationDate: '2026-03-28',
    deadline: '2026-06-05',
    status: 'closing-soon',
    description:
      'Expert advisory services for structuring climate finance instruments and green bonds for African infrastructure projects.',
    estimatedValue: '£650,000',
  },
  {
    id: '5',
    reference: 'AU-AFRI-2026-005',
    title: 'Agricultural Technology Transfer Programme',
    category: 'Agriculture',
    publicationDate: '2026-04-05',
    deadline: '2026-06-10',
    status: 'open',
    description:
      'Implementation of precision agriculture technologies and training for smallholder farmers in East Africa.',
    estimatedValue: '£3,200,000',
  },
  {
    id: '6',
    reference: 'AU-AFRI-2025-089',
    title: 'Renewable Energy Infrastructure Assessment',
    category: 'Energy',
    publicationDate: '2025-12-10',
    deadline: '2026-02-15',
    status: 'closed',
    description:
      'Comprehensive assessment of renewable energy infrastructure needs across 10 AU member states.',
    estimatedValue: '£450,000',
  },
  {
    id: '7',
    reference: 'AU-AFRI-2026-006',
    title: 'Diaspora Engagement Platform Development',
    category: 'Technology',
    publicationDate: '2026-04-18',
    deadline: '2026-06-05',
    status: 'open',
    description:
      'Development of a digital platform to connect the African diaspora worldwide with investment and partnership opportunities in Africa.',
    estimatedValue: '£850,000',
  },
  {
    id: '8',
    reference: 'AU-AFRI-2026-007',
    title: 'Women Entrepreneurs Support Programme',
    category: 'Economic Development',
    publicationDate: '2026-04-12',
    deadline: '2026-07-22',
    status: 'closing-soon',
    description:
      'Comprehensive support programme including training, mentorship, and access to finance for 1,000 women entrepreneurs across AU member states.',
    estimatedValue: '£1,800,000',
  },
  {
    id: '9',
    reference: 'AU-AFRI-2025-092',
    title: 'Transport Corridor Feasibility Study',
    category: 'Infrastructure',
    publicationDate: '2025-11-20',
    deadline: '2026-01-30',
    status: 'closed',
    description:
      'Feasibility study for multimodal transport corridor linking three AU member states.',
    estimatedValue: '£720,000',
  },
  {
    id: '10',
    reference: 'AU-AFRI-2026-008',
    title: 'Youth Leadership Development Programme',
    category: 'Education & Training',
    publicationDate: '2026-04-22',
    deadline: '2026-06-15',
    status: 'open',
    description:
      'Leadership training and exchange programme for 200 emerging African leaders aged 25-35.',
    estimatedValue: '£950,000',
  },
  {
    id: '17',
    reference: 'AU-AFRI-2026-015',
    title:
      'Framework Agreement for Healthcare Beds, Mattresses & Institutional Bedding (Lots 1–3)',
    category: 'Health & Medical',
    publicationDate: '2026-05-15',
    deadline: '2026-08-05',
    status: 'open',
    description:
      'Multi-year framework agreement for the supply of healthcare beds, mattresses, and institutional bedding to support AU healthcare, humanitarian, and staff-accommodation operations. Awarded across three independent lots. Suppliers may bid on one or more lots; specialist single-lot bids are encouraged to support African SME and regional manufacturer participation. All products must meet international safety, health, and fire-retardancy standards.\n\nLOT 1 — Healthcare & Rehabilitation Beds: Adjustable and lift-enabled hospital beds, motorised bed frames, orthopedic support mattresses, and healthcare comfort pillows for AU-supported hospitals, clinics, and rehabilitation centres.\n\nLOT 2 — Humanitarian & Refugee Bedding: Vacuum-packed mattresses, compression foam mattresses, and basic institutional bedding optimised for compact logistics — for refugee and IDP camp deployment, humanitarian field operations, and emergency response programmes.\n\nLOT 3 — Staff Accommodation Bedding: Standard spring and foam mattresses, orthopedic and memory-foam pillows, and dormitory-grade bedding for AU regional office staff housing, training centres, peacekeeping accommodation, and youth programme dormitories.',
    estimatedValue: '£3,750,000 (across all lots)',
  },
  {
    id: '11',
    reference: 'AU-AFRI-2026-009',
    title: 'Framework Agreement for Food, Beverages & FMCG Supply (Lots 1–6)',
    category: 'Food, Beverages & FMCG',
    publicationDate: '2026-05-02',
    deadline: '2026-07-30',
    status: 'open',
    description:
      'Multi-year framework agreement for the supply of food, beverages, and FMCG products to the African Union Commission. Awarded across six independent lots. Suppliers may bid on one or more lots; specialist single-lot bids are encouraged to support African SME participation. All suppliers must meet international food safety and labelling standards.\n\nLOT 1 — Chocolate & Confectionery: Premium boxed chocolates and quality confectionery for diplomatic gifting and summit hospitality; chocolate snack bars, wafer chocolates and spreads for school feeding and humanitarian operations.\n\nLOT 2 — Biscuits, Cookies & Wafer Products: Sandwich biscuits, cream-filled biscuits, wafer snacks, savoury crackers and institutional snack products for AU office catering, meetings and conferences.\n\nLOT 3 — Sweets, Candy & Treats (Children & Youth Programmes): Lollipops, fruit sweets, chewy confectionery and treats for AU-supported school feeding, refugee and IDP camp outreach, and child welfare events. Must meet child-nutrition compliance standards.\n\nLOT 4 — Coffee & Hot Beverages: Instant coffee, ground coffee, ready coffee mixes and hot beverage solutions for AU headquarters, regional offices, summits and partner events.\n\nLOT 5 — Energy & Functional Drinks: Energy drinks, functional beverages, performance and sugar-free drinks for AU field operations, sports & youth empowerment programmes and humanitarian deployments.\n\nLOT 6 — Soft Drinks & Carbonated Beverages: Carbonated soft drinks, flavoured beverages, zero-sugar drinks and multipack beverage solutions for AU summits, conferences and hospitality services.',
    estimatedValue: '£2,140,000 (across all lots)',
  },
]
